import { Button } from '@mui/material';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';

const SERVER = process.env.REACT_APP_SERVER;

function PaymentFail() {
    const navigate = useNavigate();
    const { apId } = useParams();
    let orderInfo = {
        total: 0,
        orderName: '',
        customerName: '',
        customerEmail: '',
    };

    const handleClick = async () => {
        await axios
            .post(`${SERVER}/api/payments/retry`, { applicationId: apId })
            .then((res) => {
                orderInfo = res.data;
                navigate('/payment', {
                    state: {
                        amount: orderInfo.total,
                        orderName: orderInfo.lectureTitle,
                        customerName: orderInfo.applicant.name,
                        customerEmail: orderInfo.applicant.email,
                        applicationId: res.data.applicationId,
                    },
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <div>
            결제에 실패했습니다. 다시 시도해주세요.
            <Button onClick={() => handleClick}> 결제하기 </Button>
        </div>
    );
}

export default PaymentFail;
